import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import { MultiSelect } from "react-multi-select-component";

const CropHealthList = () => {
    const navigate = useNavigate();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
   
    useEffect(() => {
        getStates();
    }, []);

    useEffect(() => {
    const savedResults = sessionStorage.getItem("searchResults");
    const savedFilters = sessionStorage.getItem("searchFilters");

    if (savedResults && savedFilters) {
        setfarmerData(JSON.parse(savedResults));
        const filters = JSON.parse(savedFilters);
        setStateValue(filters.stateValue);
        setDistrictValue(filters.districtValue);
        setsubDistrictValue(filters.subDistrictValue);
        setvillageValue(filters.villageValue);
        setselectedDataSetDistrict(filters.selectedDataSetDistrict);
        setselectedDataSetSubDistrict(filters.selectedDataSetSubDistrict);
        setselectedDataSetVillage(filters.selectedDataSetVillage);
        }
    }, []);


    useEffect(() => {

        if (isFetchingState == false) {

            handleState();
            setIsFetchingState(true);
        }

    }, [stateValue]);

    function getStates() {


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/states`,
            requestOptions

        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                console.log("localFormData", localFormDataState);
                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.stateName, value: item.stateCode })
                })
                console.log("myArray", myArray)
                setOptionState(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }


    function handleState() {
        setOptionDistrict([]);
        setDistrictValue([]);
        setsubDistrictValue([]);
        setvillageValue([]);

        if (stateValue.length > 1) {
            alert('Please select one value');
            setStateValue([]);
            return false;
        }
        else {
            if (stateValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                let stateValueData = "";

                stateValue.map((item) => {
                    stateValueData = stateValueData + item + ","
                })

                stateValueData = stateValueData.slice(0, -1);
                var raw = JSON.stringify({
                    stateCode: stateValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/district`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataDistrict = JSON.parse(result).dataContent;

                        let myArrayDistrict = [];
                        localFormDataDistrict.map((item, key) => {
                            myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                        })

                        setOptionDistrict(myArrayDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));
            }
        }

    }

    let handleChangeDistrict = (districtValue) => {
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setvillageValue([]);
        if (districtValue.length > 1) {
            alert('Please select one value');
            setDistrictValue([]);
            return false;
        }
        else {
            setDistrictValue(districtValue.map(option => option.value));
            setselectedDataSetDistrict(districtValue.map(item => `${item.stateid}|${item.value}`).join(','));

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item + ","
            })

            if (districtValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                let districtValueData = "";
                districtValue.map((item) => {
                    districtValueData = districtValueData + item.value + ","
                })

                districtValueData = districtValueData.slice(0, -1);


                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/subdistrict`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataSubDistrict = JSON.parse(result).dataContent;

                        let myArraySubDistrict = [];
                        localFormDataSubDistrict.map((item, key) => {
                            myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                        })

                        setOptionSubDistrict(myArraySubDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }
    };

    let handleChangeSubDistrict = (subdistrictValue) => {
        setvillageValue([]);
        setOptionVillage([]);
        if (subdistrictValue.length > 1) {
            alert('Please select one value');
            setsubDistrictValue([]);
            return false;
        }
        else {


            setsubDistrictValue(subdistrictValue.map(option => option.value));
            setselectedDataSetSubDistrict(subdistrictValue.map(item => `${item.districtCode}|${item.value}`).join(','));

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";

            stateValue.map((item) => {
                stateValueData = stateValueData + item
            })

            let districtValueData = "";
            districtValue.map((item) => {
                districtValueData = districtValueData + item
            })

            let subdistrictValueData = "";
            subdistrictValue.map((item) => {
                subdistrictValueData = subdistrictValueData + item.value
            })


            if (subdistrictValue.length != 0) {

                var raw = JSON.stringify({
                    stateCode: stateValueData.toString(),
                    districtCode: districtValueData.toString(),
                    subDistrictCode: subdistrictValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/village`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataVillage = JSON.parse(result).dataContent;

                        let myArrayVillage = [];
                        localFormDataVillage.map((item, key) => {
                            myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                        })

                        setOptionVillage(myArrayVillage)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));

            }
        }


    };

    const fetchDataFilterWise = async () => {
        let result;
        let result1;
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";


        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
      

        
        
       // alert(sessionStorage.getItem("schemeCodeModel"))

        if (sessionStorage.getItem("schemeCodeModel") === "5") {
            setLoaderFarmer(true);

            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",

            })
            //     const data = await result.data.dataContent;
            //     setfarmerData(data);
            //    // setfarmerData(result.data.dataContent);
            //     setIsFetching(false);

            if (result.data.dataContent.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                    stateValue,
                    districtValue,
                   
                    villageValue,
                    selectedDataSetDistrict,
                    selectedDataSetSubDistrict,
                    selectedDataSetVillage
                }));
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }


        } else if (sessionStorage.getItem("schemeCodeModel") === "7") {

            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 4,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })

            console.log("result", result);

            result1 = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getProjectDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })

            console.log("result1", result1);
            let DataContent = [...result.data.dataContent, ...result1.data.dataContent]
            console.log("dataContent", DataContent)
            setfarmerData(DataContent);
            setIsFetching(false);



        } else if (sessionStorage.getItem("schemeCodeModel") === "3") {
            result1 = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getProjectDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })

            setfarmerData(result1.data.dataContent);
            setIsFetching(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "6") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);



        }else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);



        } else if (sessionStorage.getItem("schemeCodeModel") === "8") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            //  setfarmerData(result.data.dataContent);
            //setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "10") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CDB/CDB/GetCDBFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : 0,
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "11") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetDasdFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : 0,
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            // setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            setLoaderFarmer(true);
            if (sessionStorage.getItem("userTypeCodeModel") === "5") {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                   
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": "0",
                    "PageNumber": page


                })
            }
            else {


                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "PageNumber": page


                })
            }
            //  setfarmerData(result.data.dataContent);
            //  setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "13") {
            setLoaderFarmer(true);
            if (sessionStorage.getItem("userTypeCodeModel") === "5") {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetails`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": "0",
                    "SchemeCode": "13",
                     "stateCode": stateValueData,
               "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,


                })
            }
            else {


                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetails`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "SchemeCode": "13",
                     "stateCode": stateValueData,
               "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,


                })
            }
            //   setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
            sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
              if (result.data.success != true) {
                  alert('No Data Found.');
                  setLoaderFarmer(false);
            }

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "1") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page
            })
            //setfarmerData(result.data.dataContent);
            // setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else {
            let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";

        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
               "stateCode": stateValueData,
               "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,
                "PageNumber": page
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);


             const data = await result.data.dataContent;
           
            console.log('data---------------',data);
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
            sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
            if (result.data.success != true) {
                  alert('No Data Found.');
                  setLoaderFarmer(false);
            }


        }



        // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);

    };

    let handleChange = (stateValue) => {
        console.log("selected State", stateValue);
        setIsFetchingState(false);
        setStateValue(stateValue.map(option => option.value));

    };

    let handleChangeVillage = (villageValue) => {
        if (villageValue.length > 1) {
            alert('Please select one value');
            setvillageValue([]);
            return false;
        }
        else {

            setvillageValue(villageValue.map(option => option.value));
            setselectedDataSetVillage(villageValue.map(item => `${item.subDistrictCode}|${item.value}`).join(','));
        }
    };

    function formatData(value) {
        if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
            return value.componentName
        }
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Honey Processing Unit"
        } else if (value.orgTypeCode === 2) {
            return "Honey Testing Unit"
        } else if (value.orgTypeCode === 3) {
            return "Honey CHC"
        } else if (value.orgTypeCode === 4) {
            return "Beeflora Plantation"
        }
    }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
      setLoaderFarmer(true);
      
      let stateValueData = "";
      let districtValueData = "0";
      let subdistrictValueData = "0";
      let villageValueData = "0";

      // Concatenate all state values with a comma
      stateValue.forEach((item) => {
        stateValueData += item + ",";
      });
      // Remove trailing comma
      stateValueData = stateValueData.slice(0, -1);

      // If stateValueData is null or empty, set stateCode to "0"
      const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

      if (selectedDataSetDistrict !== "") {
        const districtParts = selectedDataSetDistrict.split("|");
        districtValueData = districtParts[1];
      }
      if (selectedDataSetSubDistrict !== "") {
        const SubdistrictParts = selectedDataSetSubDistrict.split("|");
        subdistrictValueData = SubdistrictParts[1];
      }
      if (selectedDataSetVillage !== "") {
        const VillageDataParts = selectedDataSetVillage.split("|");
        villageValueData = VillageDataParts[1];
      }
      console.log("stateValueData", stateCode);
      console.log("districtValueData", districtValueData);
      console.log("subdistrictValueData", subdistrictValueData);
      console.log("villageValueData", villageValueData);

      let result;
      if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
          {
           
            stateCode: stateCode, // Use our conditional stateCode here
            districtCode: districtValueData,
            subDistrictCode: subdistrictValueData,
            villageCode: villageValueData,
            PageNumber: 1,
          }
        );
        if (result.data.success === true) {
          const data = await result.data.dataContent;
          setIsFetching(false);
          setLoaderFarmer(false);
          return data;
        } else {
          alert("something went wrong.");
          setLoaderFarmer(false);
        }
      }
    };


    const handleExportDataNew = async () => {
        
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }
    const handleExportDataNewu = async () => {
    try {
        // Fetch data
        const farmerDataExportNew = await fetchDataExporttoCsv();
       //  console.log("aaaaaaaaaaaaaaaaaaaaaaa",farmerDataExportNew.data.dataContent)
        if(farmerDataExportNew.data.dataContent.length !=0){
        // Check if data is valid
        if (!farmerDataExportNew || !Array.isArray(farmerDataExportNew)) {
            console.error("Error: fetchDataExporttoCsv() returned invalid data", farmerDataExportNew);
            alert("Failed to export: No data available.");
            return;
        }

        // Allowed keys for export
       // const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName']
       

        // Transform data
        const result = farmerDataExportNew.map(obj => {
            let newObj = {};
            allowed.forEach(key => {
                newObj[key] = obj[key] ?? ""; // Ensure empty string for missing values
            });
            return newObj;
        });

        console.log("Export Data:", result);
        // Add export logic here
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
       } 
    } catch (error) {
        console.error("Error in handleExportDataNew:", error);
        alert("An error occurred while exporting data.");
    }
    };


    const handleExportData = () => {
        // alert(sessionStorage.getItem("schemeCodeModel") );
        let allowed;

        allowed = ['schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName','seasonName','cropCategoryName','cropName','cropStageName','cropingTypeName','schemeName','polygonArea','cropVarity'];

        var result = farmerData?.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });


            return newObj;
        });





        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
    };


    function ValidateUpdateUser() {

        let valid = false;

        if (mobilenoValue === "") {
            alert("Enter Mobile no")

            valid = false;
            return;
        } else {
            valid = true;

        }
        if (landareaValue === "") {
            alert("Enter land area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (totalareaValue === "") {
            alert("Enter total area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (surveynoValue === "") {
            alert("Enter Survey No")

            valid = false;
            return;
        } else {
            valid = true;

        }


        if (valid === true) {
            UpdateNewUser()
        }



    }

    function UpdateNewUser() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "farmerCode": editCode,
            "mobileNo": mobilenoValue,
            "surveyNo": surveynoValue,
            "landArea": landareaValue,
            "totalArea": totalareaValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Nature/FarmerDetails/UpdateFarmerDetails`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
               // alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    // navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));

    }

    const handlePrevPage = async () => {
        setLoaderFarmer(true);
        let result;
        setPage(page - 1);
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1
            })
        }
       else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page - 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        setIsFetching(false);
        setHasNextPage(true)
    };

    const handleNextPage = async () => {
        setLoaderFarmer(true);

        setPage(page + 1);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page + 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        if (result.data.message === "Data Not Found") {
            setHasNextPage(false)
        }
        setIsFetching(false);
    };


    function handleSurveyNumber(value) {
        const valueFinal = value.replace(/\D/g, "");
        setSurveyValue(valueFinal)
    }

    function handleSurveyorName(value) {
        //alert(value);
       // const valueFinal = value.replace(/\D/g, "");
        setSurveyorNameValue(value)
        console.log("value==========",value)
        
    }



    const fetchDataFilterWises = async () => {
        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";
        


        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
      

        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {

            if (surveyValue != '') {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetails`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "CropSurveyCode": surveyValue
                });
            }
            else {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "schemeCode": "12",
                    "stateCode": stateValueData,
                    "districtCode": districtValueData,
                    "subDistrictCode": subdistrictValueData,
                    "villageCode": villageValueData,
                    "surveyorName": surveyorNameValue,
                    "cropSeasonValue": cropSeasonValue,
                    "cropGroupValue": cropGroupValue,
                    "cropNameValue": cropNameValue,
                    "fromdate": startDate,
                    "todate": endDate,
                    "PageNumber": 1
                });
            }


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                    stateValue,
                    districtValue,
                   
                    villageValue,
                    selectedDataSetDistrict,
                    selectedDataSetSubDistrict,
                    selectedDataSetVillage
                }));    
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "14") {

          
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEO_OP/getNMEOFarmerDetailsList`, {
                   
                    "schemeCode": "14",
                    "orgTypeCode": "1",
                    "lngA_FarmerCode": "0",
                    "int_Block_Code": "0",
                    "lng_SurveyUserCode": "0",
                    "str_MobileNo": "",
                    "int_State_Code": stateValueData,
                    "int_District_Code": districtValueData,
                    "int_SubDistrict_Code": subdistrictValueData,
                    "int_VillageCode": villageValueData,
         });
            


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                    stateValue,
                    districtValue,
                   
                    villageValue,
                    selectedDataSetDistrict,
                    selectedDataSetSubDistrict,
                    selectedDataSetVillage
                }));    
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "9") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           } 

        if (sessionStorage.getItem("schemeCodeModel") === "15") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/RKVY/RKVYProject/RKVYProjectExtList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": districtValueData,
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           }         

    };

    function ClearSearch(){
        setStateValue([]);
        setOptionDistrict([]);
        setDistrictValue([]);
        setfarmerData([]);
        setselectedDataSetDistrict('');
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setOptionVillage([]);
        setvillageValue([]);
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");
    }

    function ValidateAddUser() {
    //alert(sessionStorage.getItem("schemeCodeModel"))
   // alert()
   
    if (stateValue.length === 0) {
       
         setErrorMessage("Please select at least one State.");
            return false;
    }
    if (stateValue.length > 1) {
       setErrorMessage("Please select only one State.");
            return false;
    }
    
    if (districtValue.length > 1) {
        setErrorMessage('Please select only one District');
        return false;
    }
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;
        
    }

    }
    // If all validations pass, fetch the filtered data
    setErrorMessage("") 
    fetchDataFilterWise();

    }


    function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }



    const columns = useMemo(() => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

        return [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'schemeName',
                header: 'schemeName',
            },{
                accessorKey: 'stateName',
                header: 'State',
            },
            {
                accessorKey: 'districtName',
                header: 'District',
            }, {
                accessorKey: 'subDistrictName',
                header: 'subDistrictName',
            },  {
                accessorKey: 'villageName',
                header: 'villageName',
            }, {
                accessorKey: 'cropCategoryName',
                header: 'cropCategoryName',
            },{
                accessorKey: 'cropName',
                header: 'cropName',
            },


            
           
                 ...(schemeCodeModel === "15" ? [
        { accessorKey: 'userName', header: 'User Name' },
        { accessorKey: 'sectorName', header: 'Sector Name' },
        { accessorKey: 'projectStatus', header: 'Project Status' }
    ] : []),

            // View Details Button Logic
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessor: '',
                header: 'View Details',
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/survey/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            } : (schemeCodeModel === "9") ? {
                accessor: '',
                header: 'Action',
                Cell: cell => (<>
                    <i className="btn" type="button" onClick={() => navigateData(cell.row.original)}> <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setEditCode(cell.row.original.farmerCode)}> <FontAwesomeIcon icon={faEdit} /></i>
                </>)
            } : {
                accessor: '',
                header: 'View Details',
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            },
       
        ].filter(Boolean); // Use .filter(Boolean) to remove null entries
    }, []);


    return (
        <>
          
           <section className="section">

                <div className="row surveydetailsBg">
                    <div className="col-md-3">
                        <label htmlFor="State" className="form-label">
                            State
                        </label><label style={{ color: "red" }}>*</label>
                        <MultiSelect
                            options={optionState}
                            value={optionState.filter(option => stateValue.includes(option.value))}
                            // value={selected}
                            onChange={handleChange}
                            labelledBy={"Select"}
                            isCreatable={true}
                            defaultValue={stateValue} />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="District" className="form-label">
                            District
                        </label><label style={{ color: "red" }}></label>
                        <MultiSelect
                            options={optionDistrict}
                            value={optionDistrict.filter(option => districtValue.includes(option.value))}
                            onChange={handleChangeDistrict}

                            labelledBy={"Select"}
                            isCreatable={true}
                            defaultValue={districtValue} />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="SubDistrict" className="form-label">
                            Sub District
                        </label><label style={{ color: "red" }}></label>
                        <MultiSelect
                            options={optionSubDistrict}
                            value={optionSubDistrict.filter(option => subdistrictValue.includes(option.value))}
                            // value={selected}
                            onChange={handleChangeSubDistrict}
                            labelledBy={"Select"}
                            isCreatable={true}
                            defaultValue={subdistrictValue} />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="Village" className="form-label">
                            Village
                        </label><label style={{ color: "red" }}></label>
                        <MultiSelect
                            options={optionVillage}
                            value={optionVillage.filter(option => villageValue.includes(option.value))}
                            onChange={handleChangeVillage}
                            labelledBy={"Select"}
                            isCreatable={true}
                            defaultValue={villageValue} />
                    </div>
                    
                  <br /> <br />                     
                  <div className="col-md-12 d-flex justify-content-md-center mt-3">

                    <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAddUser} >Submit</button>
                    <button type="button" className="btn btn-success me-md-2"  onClick={ClearSearch}>Clear</button>
                </div>

                </div>
                
                {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                         {errorMessage}
                        </div>
                    )} 

       
            {LoaderFarmer === false ? "" : <div class="overlay">
                <div class="overlay__inner">
                    <div class="overlay__content"><span class="spinner"></span></div>
                </div>
            </div>}


                    {(farmerData.length!=0  &&
                    <div className="row justify-content-lg-center">

                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={farmerData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sessionStorage.getItem("schemeCodeModel") === "12" ?
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportDataNew}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>

                                                :
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                            }

                                        </Box>
                                    )}
                                />
                                

                            </div>

                        </div>


                    </div>
                )}
           </section>

        

         
          
        </>
    )
}

export default CropHealthList;